var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ConnectionError, InternalServerError, UnauthorizedError } from '../errors';
/**
 * Executes a GraphQL query or mutation.
 * @throws {@link UnauthorizedError}
 * @throws {@link InternalServerError}
 * @throws {@link ConnectionError}
 */
export function queryOrMutate({ apiUrl, protocol }, request, accessToken) {
    return __awaiter(this, void 0, void 0, function* () {
        const headers = { 'Content-Type': 'application/json' };
        if (accessToken !== undefined)
            headers.Authorization = `Bearer ${accessToken}`;
        const response = yield fetch(`${protocol}://${apiUrl}/query-or-mutation`, {
            method: 'POST',
            headers,
            body: JSON.stringify(request),
        });
        if (response.status === 401)
            throw new UnauthorizedError();
        if (response.status >= 500 && response.status <= 599)
            throw new InternalServerError();
        if (response.status !== 200)
            throw new ConnectionError();
        return yield response.json();
    });
}
/**
 * Creates a GraphQL subscription.
 * @param path - For example, if the subscription is hosted on http://localhost/accounts-subscription, this should be
 * `'/accounts-subscription'`.
 * @param query - GraphQL document (i.e., the query to send to the GraphQL server).
 */
export function subscribe({ apiUrl, protocol }, accessToken, path, query, onMessage, onError) {
    const socket = new WebSocket(`${protocol}://${apiUrl}${path}`);
    socket.addEventListener('open', () => {
        socket.send(accessToken);
        socket.send(JSON.stringify({ query }));
    });
    socket.addEventListener('message', ({ data }) => onMessage(JSON.parse(data)));
    socket.addEventListener('error', onError);
    return () => socket.close();
}
